import { useEffect, useState } from 'react';
import workspaceAPI from '../../services/workspaceAPI';

const monthLabel = (row) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return row?._id ? `${months[row._id.month - 1]} ${row._id.year}` : '—';
};

const WorkspaceAnalytics = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    workspaceAPI
      .getAnalytics()
      .then((res) => setData(res.data))
      .catch((err) => setError(err.response?.data?.message || 'Failed to load analytics'));
  }, []);

  if (error) return <p className="workspace-alert error">{error}</p>;
  if (!data) return <p>Loading...</p>;

  const { summary, monthly, recentPayments } = data;

  return (
    <div>
      <h1 className="workspace-page-title">Revenue & analytics overview</h1>
      <p className="workspace-page-subtitle">Track earnings, commissions, and monthly payment trends.</p>
      <div className="workspace-grid">
        <div className="workspace-card">
          <h3>Earned</h3>
          <p className="value">₹{Number(summary?.totalEarned || 0).toLocaleString('en-IN')}</p>
        </div>
        <div className="workspace-card">
          <h3>Commission</h3>
          <p className="value">₹{Number(summary?.totalCommission || 0).toLocaleString('en-IN')}</p>
        </div>
        <div className="workspace-card">
          <h3>Net</h3>
          <p className="value">₹{Number(summary?.netBalance || 0).toLocaleString('en-IN')}</p>
        </div>
        <div className="workspace-card">
          <h3>Transactions</h3>
          <p className="value">{summary?.transactionCount || 0}</p>
        </div>
      </div>
      <div className="workspace-table-wrap" style={{ marginTop: 20 }}>
        <h3 style={{ padding: '14px 14px 0' }}>Monthly revenue</h3>
        <table className="workspace-table">
          <thead>
            <tr>
              <th>Month</th>
              <th>Revenue</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {(monthly || []).map((row, i) => (
              <tr key={i}>
                <td>{monthLabel(row)}</td>
                <td>₹{Number(row.revenue || 0).toLocaleString('en-IN')}</td>
                <td>{row.bookings}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="workspace-table-wrap" style={{ marginTop: 20 }}>
        <h3 style={{ padding: '14px 14px 0' }}>Recent payments</h3>
        <table className="workspace-table">
          <thead>
            <tr>
              <th>Property</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {(recentPayments || []).map((p) => (
              <tr key={p._id}>
                <td>{p.property?.name || '—'}</td>
                <td>₹{Number(p.hostAmount || 0).toLocaleString('en-IN')}</td>
                <td>{p.paidAt ? new Date(p.paidAt).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WorkspaceAnalytics;
